import React, { useEffect, useState } from "react";
import { X, Dices, Info } from "lucide-react";
import api from "../lib/api";
import { rarityMeta, RARITY_FULL } from "../lib/helpers";

export default function ProbabilitiesModal({ setId, setName, onClose }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/probabilities/${setId}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [setId]);

  return (
    <div className="fixed inset-0 z-50 bg-[#0b1324]/80 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={onClose} data-testid="probabilities-modal">
      <div className="w-full max-w-md bg-[#eef8ff] rounded-t-3xl sm:rounded-3xl max-h-[92vh] overflow-y-auto no-scrollbar" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-[#eef8ff]/95 backdrop-blur px-4 py-3 flex items-center justify-between border-b border-sky-100">
          <div className="font-display font-bold flex items-center gap-2"><Dices size={18} className="text-purple-500" /> Probabilità</div>
          <button onClick={onClose} data-testid="prob-close-btn" className="pill-soft w-9 h-9 flex items-center justify-center">
            <X size={18} />
          </button>
        </div>
        <div className="p-4">
          <p className="text-sm luma-muted font-semibold">{setName}</p>
          {err && <p className="mt-4 text-sm luma-muted">Nessuna probabilità disponibile per questa espansione.</p>}
          {data && (
            <>
              <div className="mt-3 luma-card !rounded-2xl p-3.5 bg-amber-50 border-amber-200 flex gap-2.5">
                <Info size={18} className="text-amber-600 shrink-0 mt-0.5" />
                <p className="text-[13px] font-semibold text-amber-800">{data.disclaimer}</p>
              </div>

              <div className="mt-4 space-y-2.5">
                <p className="text-xs font-bold uppercase tracking-wider luma-muted">Composizione bustina ({data.cards_per_pack} carte)</p>
                {data.slots.map((s, i) => (
                  <div key={i} className="luma-card !rounded-2xl p-3">
                    <div className="flex items-center justify-between">
                      <span className="font-bold text-sm">{s.label}</span>
                      {s.pool_count != null && <span className="text-xs luma-muted font-mono">{s.pool_count} carte</span>}
                    </div>
                    {s.distribution && (
                      <div className="mt-2 space-y-1.5">
                        {s.distribution.map((d) => {
                          const meta = rarityMeta(d.rarity);
                          return (
                            <div key={d.rarity} className="flex items-center gap-2">
                              <span className={`chip ${meta.cls} !text-[10px] !px-2 !py-0.5 w-11 text-center`}>{meta.label}</span>
                              <div className="flex-1 h-2.5 rounded-full bg-sky-100 overflow-hidden">
                                <div className="h-full bg-gradient-to-r from-purple-400 to-pink-400" style={{ width: `${d.weight}%` }} />
                              </div>
                              <span className="text-xs font-bold tabular-nums w-14 text-right">{d.weight}%</span>
                              <span className="text-[10px] luma-muted w-10 text-right">{d.count} c.</span>
                            </div>
                          );
                        })}
                        <p className="text-[11px] luma-muted mt-1">
                          Pesi ribilanciati sui gruppi di rarità effettivamente presenti ({RARITY_FULL.R ? "" : ""}R/SR/SEC/L).
                        </p>
                      </div>
                    )}
                  </div>
                ))}

                <div className="luma-card !rounded-2xl p-3">
                  <div className="flex items-center justify-between">
                    <span className="font-bold text-sm">Sostituzione con Variante</span>
                    <span className="text-xs font-bold text-purple-600">{data.variant_replacement.probability_pct}%</span>
                  </div>
                  <p className="text-[13px] luma-muted mt-1">{data.variant_replacement.description} Pool: {data.variant_replacement.pool_count} artwork.</p>
                </div>
              </div>

              <div className="mt-4 grid grid-cols-2 gap-2.5 text-center">
                <div className="luma-card !rounded-2xl p-2.5">
                  <div className="font-display font-bold text-lg">{data.base_cards}</div>
                  <div className="text-[11px] luma-muted font-semibold">numeri carta</div>
                </div>
                <div className="luma-card !rounded-2xl p-2.5">
                  <div className="font-display font-bold text-lg">{data.variants_total}</div>
                  <div className="text-[11px] luma-muted font-semibold">artwork totali</div>
                </div>
              </div>
              <p className="text-[11px] luma-muted mt-3 text-center font-mono">motore {data.version}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
